import { getWorkflowCapabilities } from '@jira/project-settings__workflow-services-capabilities/src/getWorkflowCapabilities.tsx';
import type { WorkflowCapabilities } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
// eslint-disable-next-line jira/import-whitelist
import {
	prefetchApiReadyMark,
	prefetchApiStartMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/react-resource-router';

export const fetchWorkflowCapabilities = async (
	routerContext: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
): Promise<WorkflowCapabilities> => {
	const { match } = routerContext;

	const { isAnonymous, cloudId } = tenantContext;

	if (isAnonymous) {
		throw new Error("Workflows can't be edited in anonymous mode.");
	}
	if (!match.params.workflowId && !match.params.projectKey && !match.params.issueTypeId) {
		throw new Error('Workflow ID, project Key, or issue type ID is not defined.');
	}

	try {
		// better way to monitor perf?
		setMark(prefetchApiStartMark);

		let workflowCapabilities: WorkflowCapabilities | null = null;
		if (match.params.workflowId) {
			workflowCapabilities = await getWorkflowCapabilities(cloudId, {
				workflowId: match.params.workflowId,
			});
		} else if (match.params.projectKey && match.params.issueTypeId) {
			const workflowIdentifier = {
				projectKey: match.params.projectKey,
				issueTypeId: match.params.issueTypeId,
			};
			workflowCapabilities = await getWorkflowCapabilities(cloudId, workflowIdentifier);
		}
		if (!workflowCapabilities) {
			throw new Error('Workflow ID, project ID, or issue type ID is not defined.');
		}

		setMark(prefetchApiReadyMark);
		return workflowCapabilities;

		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.admin-pages.workflows.workflow-capabilities.getData',
				message: 'An error was thrown while prefetching workflow capabilities data',
				name: 'ResourceError',
			},
			error,
		);
	}
};
